export default {
  user_type: null,
};
